import React, { useState } from 'react';

import Alert, { useAlert } from 'components/snacks/Alert';

import { axiosInstance } from 'api/Api';

const ChangePassword = () => {
  const [nowPass, setNowPass] = useState('');
  const [newPass1, SetNewPass1] = useState('');
  const [newPass2, SetNewPass2] = useState('');

  const alert_timeout = 10000;
  const alertStore = useAlert(alert_timeout);

  const submitForm = (e) => {
    e.preventDefault();
    // window.location.pathname = "/login";
    let error_message = "";
    if (!nowPass || !newPass1 || !newPass2) {
      error_message = 'لطفا همه فیلد هارا تکمیل کنید';
    } else if ( newPass1 !== newPass2 )
    {
      error_message = 'کلمه عبور های جدید باید یکسان باشند';
    }
    if (error_message !== '')
    {
      alertStore.AddAlert({
        key: 'validation',
        message: error_message,
        severity: 'error',
        auto_hide: true
      });
    }
    else
    {
      let formData = new FormData();
      formData.append('old_password', nowPass);
      formData.append('new_password', newPass1);
      formData.append('repeat_password', newPass2);
      axiosInstance()
        .post('change-password', formData)
        .then((res) => {
          if (res.data.status === 200) {
            window.location.pathname = '/login';
          } else
          {
            alertStore.AddAlert({
              key: '400',
              message: res.data.msg,
              severity: 'error',
              auto_hide: true
            });
          }
        });
    }
  };

  return (
    <section className="p-5 normal-shadow rounded bg-white">
      <div className="row">
        <div className="col-12 col-md-8 order-1 order-md-0">
          <p className="m-0 f-13">تغییر کلمه عبور</p>
          <hr />
          <form method="post" className="row" onSubmit={submitForm}>
            <div className="col-12">
              <label htmlFor="change_now_pass">کلمه عبور فعلی</label>
              <input
                type="password"
                className="form-control login-input"
                id="change_now_pass"
                value={nowPass}
                onChange={(e) => setNowPass(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mt-5">
              <label htmlFor="change_new_pass_1">کلمه عبور جدید</label>
              <input
                type="password"
                className="form-control login-input"
                id="change_new_pass_1"
                value={newPass1}
                onChange={(e) => SetNewPass1(e.target.value)}
              />
            </div>
            <div className="col-12 col-md-6 mt-5">
              <label htmlFor="change_new_pass_2">تایید کلمه عبور جدید</label>
              <input
                type="password"
                className="form-control login-input"
                id="change_new_pass_2"
                value={newPass2}
                onChange={(e) => SetNewPass2(e.target.value)}
              />
            </div>
            <div className="col-12 mt-5">
              <button type="submit" className="btn btn-success">
                تغییر کلمه عبور
              </button>
            </div>
          </form>
        </div>
        <div className="col-12 col-md-4 order-0 order-md-1">
          <img
            src="/assets/media/ezgif.com-gif-maker.jpg"
            alt="form"
            className="img-fluid"
          />
        </div>
      </div>
      {
        <Alert
          alerts={alertStore.alert}
          close={alertStore.RemoveAlert}
          timeout={alert_timeout}
        />
      }
    </section>
  );
};

export default ChangePassword;
